const apiUrl = process.env.REACT_APP_API_URL;
export const GetInteraccionsId = async (id_user : string, id_dubte: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id_user}/dubtes/${id_dubte}/interaccions`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
